export default __webpack_public_path__ + "assets/img/img-logo-goto.b382b34f83156ddbaf09304d3e2dc5a5.svg";